import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { i18n } from '../context/LanguageContext';
import { haptics } from '../utils/haptics';
import ekthetsIcon from '../assets/EKTHETES_ICON.png';
import ekthemataIcon from '../assets/EKTHEMATA_ICON.png';
import PavIcon from '../assets/PAVILION_ICON.png';
import MapIcon from '../assets/MAP_ICON.png';
import HomeIcon from  '../assets/UTF-8HOME_ICON.png'
const BottomNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const navItems = [
     {
        name: i18n.t('home') || 'Home',
        icon: HomeIcon,
        path: '/'
      },
    {
      name: i18n.t('companies') || 'Companies',
      icon: ekthetsIcon,
      path: '/exhibitors'
    },
    {
      name: i18n.t('exhibits') || 'Exhibits',
      icon: ekthemataIcon,
      path: '/exhibits'
    },
   
    {
      name: i18n.t('pavilions') || 'Pavilions',
      icon: PavIcon,
      path: '/pavilions'
    },
    {
      name: i18n.t('mapScreen') || 'Map',
      icon: MapIcon,
      path: '/map'
    }
  ];

  return (
    <>
      <div className="bottom-nav-spacer"></div>
      <nav className="bottom-nav">
        {navItems.map(item => (
          <button
            key={item.path}
            className={`bottom-nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => { haptics.tap(); navigate(item.path); }}
          >
            <img src={item.icon} alt={item.name} className="bottom-nav-icon" />
            <span className="bottom-nav-label">{item.name}</span>
          </button>
        ))}
      </nav>
      
      <style jsx>{`
        /* ── Bottom Navigation — floating glass dock ──────────────── */
        .bottom-nav-spacer {
          height: 88px; /* 64px dock + 14px gap + 10px breathing room */
          width: 100%;
        }

        .bottom-nav {
          position: fixed;
          bottom: 14px;
          left: 12px;
          right: 12px;
          margin: 0 auto;
          max-width: 440px;
          height: 64px;
          border-radius: 22px;
          background: var(--app-glass-bg, rgba(7, 20, 42, 0.72));
          backdrop-filter: var(--app-glass-blur, blur(20px) saturate(160%));
          -webkit-backdrop-filter: var(--app-glass-blur, blur(20px) saturate(160%));
          border: 1px solid rgba(255, 255, 255, 0.1);
          display: flex;
          justify-content: space-around;
          align-items: center;
          z-index: 1000;
          box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, 0.08),
            0 4px 12px rgba(0, 0, 0, 0.35),
            0 16px 40px rgba(0, 0, 0, 0.45);
          padding: 0 6px;
        }

        @media (display-mode: standalone) {
          .bottom-nav {
            bottom: calc(14px + env(safe-area-inset-bottom));
          }
          .bottom-nav-spacer {
            height: calc(88px + env(safe-area-inset-bottom));
          }
        }

        .bottom-nav-item {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 3px;
          background: none;
          border: none;
          color: rgba(248, 250, 252, 0.55);
          padding: 8px 4px;
          flex: 1;
          max-width: 90px;
          cursor: pointer;
          height: 100%;
          border-radius: 16px;
          transition:
            color 0.2s ease,
            transform 0.15s ease;
        }

        .bottom-nav-item:active {
          transform: scale(0.92);
        }

        @media (hover: hover) {
          .bottom-nav-item:hover {
            color: rgba(248, 250, 252, 0.9);
          }
        }

        /* Active pill — tinted glass behind icon + label */
        .bottom-nav-item.active {
          color: #38bdf8;
        }

        .bottom-nav-item.active::before {
          content: "";
          position: absolute;
          inset: 7px 2px;
          border-radius: 14px;
          background: linear-gradient(
            160deg,
            rgba(56, 189, 248, 0.2),
            rgba(56, 189, 248, 0.05)
          );
          box-shadow:
            inset 0 0 0 1px rgba(56, 189, 248, 0.25),
            0 0 16px rgba(56, 189, 248, 0.15);
          z-index: 0;
          pointer-events: none;
          animation: dock-pill-in 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) both;
        }

        @keyframes dock-pill-in {
          from { opacity: 0; transform: scale(0.85); }
          to   { opacity: 1; transform: scale(1); }
        }

        .bottom-nav-icon {
          width: 24px;
          height: 24px;
          object-fit: contain;
          position: relative;
          z-index: 1;
          transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
          filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.25));
        }

        .bottom-nav-item.active .bottom-nav-icon {
          transform: scale(1.1) translateY(-1px);
          filter: drop-shadow(0 0 6px rgba(56, 189, 248, 0.45));
        }

        .bottom-nav-label {
          font-size: 0.68rem;
          font-weight: 600;
          letter-spacing: -0.01em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;
          position: relative;
          z-index: 1;
        }

        @media (prefers-reduced-motion: reduce) {
          .bottom-nav-item,
          .bottom-nav-icon {
            transition: none;
          }
          .bottom-nav-item.active::before {
            animation: none;
          }
        }
      `}</style>
    </>
  );
};

export default BottomNavBar;